import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, WizardServiceLocator, DialogService } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { TerminalVisitorRegistration, TerminalVisitorRegistrationResult } from '../widgets/terminal/visitor-registration.model';
import { PageCall } from 'src/tmc-common/model/terminal.model';

export class VisitorRegistrationSendDataToBackendController extends AbstractStepController {

    errorOccured = false;

    tmcHttpService: HttpService;

    constructor() {
        super();
        this.tmcHttpService = WizardServiceLocator.injector.get(HttpService);
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {
    }

    public handleFlow(): FlowStepHandleResult {
        const result = new FlowStepHandleResult();
        result.type = HandleResultType.PROCESSING;

        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('send data to backend started');

        this.saveRegistrationAndShowFinishPage();

        return result;
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();
        return controls;
    }


    private saveRegistrationAndShowFinishPage(): Promise<void> {
        this.dashboardContext.setContextValue(TerminalContextConstants.registrationFinished, new Date().getTime());
        return this.saveMasterData()
            .then(() => {
                // Finally call next Wizard Step
                if (!this.errorOccured) {
                    this.wizardComponent.next();
                }
            });
    }


    private saveMasterData() {

        const dto = new TerminalVisitorRegistration();
        // Terminal identifier setzen
        dto.terminalIdentifier = this.dashboardContext.getContextValue('terminalIdentifier');
        dto.name = this.dashboardContext.getContextValue(TerminalContextConstants.lastname);
        dto.firstname = this.dashboardContext.getContextValue(TerminalContextConstants.firstname);
        dto.company = this.dashboardContext.getContextValue(TerminalContextConstants.company);
        dto.numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
        dto.reason = this.dashboardContext.getContextValue(TerminalContextConstants.reasonForVisit);
        dto.visitedPerson = this.dashboardContext.getContextValue(TerminalContextConstants.visitedPerson);
        dto.gcCaseId = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseId);
        dto.gcCaseUrl = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseUrl);
        dto.messagingLanguage = this.dashboardContext.getContextValue(TerminalContextConstants.language);
        dto.visitorType = this.dashboardContext.getContextValue('visitorType');

        const logContainer: LogContainer = this.dashboardContext.getContextValue(TerminalContextConstants.logContainer);

        for (const logEntry of logContainer.logEntries) {
            dto.pageCalls.push(new PageCall({ key: logEntry.message, timestamp: logEntry.timestamp }));
        }

        dto.registrationId = this.dashboardContext.getContextValue(TerminalContextConstants.registrationId);
        dto.registrationCode = this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode);
        dto.registrationFinished = this.dashboardContext.getContextValue(TerminalContextConstants.registrationFinished);
        dto.registrationStarted = this.dashboardContext.getContextValue(TerminalContextConstants.registrationStarted);
        const driverCommunication = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication);
        dto.smartphoneRequired = driverCommunication === TerminalContextConstants.DRIVER_COMMUNICATION_LOANER;
        const smartphoneConnected = this.dashboardContext.getContextValue(TerminalContextConstants.smartphoneConnected);
        dto.smartphoneConnected = smartphoneConnected == null || smartphoneConnected === true;
        dto.smartphoneCommunicationEnabled = this.dashboardContext.getContextValue('smartphoneConnectionEnabled') === true;
        dto.needsAreaAccess = this.dashboardContext.getContextValue('needsAreaAccess');

        dto.inviterId = this.dashboardContext.getContextValue('inviterId');

        const instructionTestResult = this.dashboardContext.getContextValue('instruction-test-result');
        dto.instructionTestResult = instructionTestResult == null ? null : instructionTestResult === true;
        const instrcutionTestErrorCount = this.dashboardContext.getContextValue('instruction-test-failure-count');
        dto.instructionTestFailureCount = instrcutionTestErrorCount == null ? 0 : instrcutionTestErrorCount;
        dto.sucessfullyFinishedInstructionTests = this.dashboardContext.getContextValue('sucessfully-finished-instruction-tests');

        return this.tmcHttpService.postWithContext(`${environment.registrationVisitorFinishEndpoint}`, dto)
            .toPromise()
            .then(response => {
                console.log('saveMasterData call succeeded:', response);
                // We update the registrationId
                const terminalRegistrationResult = new TerminalVisitorRegistrationResult(response);
                this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, terminalRegistrationResult.registrationId);
                this.dashboardContext.setContextValue(TerminalContextConstants.lastname, terminalRegistrationResult.name);
                this.dashboardContext.setContextValue(TerminalContextConstants.firstname, terminalRegistrationResult.firstname);
                this.dashboardContext.setContextValue(TerminalContextConstants.company, terminalRegistrationResult.company);
                this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, terminalRegistrationResult.visitedPerson);
                this.dashboardContext.setContextValue('needsAreaAccess', terminalRegistrationResult.needsAreaAccess);
                this.dashboardContext.setContextValue(TerminalContextConstants.gatekeeperMandatory, terminalRegistrationResult.gatekeeperMandatory);
                this.dashboardContext.setContextValue(TerminalContextConstants.registrationCode, terminalRegistrationResult.registrationCode);
                this.dashboardContext.setContextValue(TerminalContextConstants.validity, terminalRegistrationResult.validity);
                this.dashboardContext.setContextValue('visitorType', terminalRegistrationResult.visitorType);
                this.dashboardContext.setContextValue('informationTexts', terminalRegistrationResult.informationTexts);
                this.dashboardContext.setContextValue('inviterId', terminalRegistrationResult.inviterId);
            }, error => {
                console.log('saveMasterData call failed:', error);
                this.showHttpError();
            });
    }

    private showHttpError() {
        this.errorOccured = true;

        const matDialog = WizardServiceLocator.injector.get(DialogService);
        matDialog.showInfoDialog(
          'tmc-yard.widgets.registration-terminal.http.error.title',
          'tmc-yard.widgets.registration-terminal.http.error.message',
        ).afterClosed().subscribe(
            () => this.wizardComponent.restartWizard()
        );
    }
}
